module.exports = __webpack_public_path__ + "static/media/down-arrow.5bdf2c30.svg";